import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import useStyles from "./ErrorPageStyle";

export default function ErrorPage() {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Typography variant="h1">404</Typography>
      <Typography variant="h5">THE PAGE YOU'RE LOOKING FOR WAS NOT FOUND!</Typography>
    </Card>
  );
}
